{
  "alert.informative": "Informační",
  "alert.negative": "Negativní",
  "alert.notice": "Upozornění",
  "alert.positive": "Pozitivní",
  "attachmentlist.nextAttachments": "Zobrazit další přílohy",
  "attachmentlist.previousAttachments": "Zobrazit předchozí přílohy",
  "chat.newMessage": "Nová zpráva",
  "chat.scrollToBottom": "Posunout na konec",
  "messagefeedback.thumbDown": "Špatná odpověď",
  "messagefeedback.thumbUp": "Dobrá odpověď",
  "promptfield.aiDisclaimer": "Odpovědi jsou generovány pomocí umělé inteligence a mohou obsahovat nepřesnosti. Před použitím je zkontrolujte.",
  "promptfield.aiUserGuidlines": "Pokyny pro uživatele umělé inteligence",
  "promptfield.attachments": "Přílohy",
  "promptfield.insertButton": "Přidat",
  "promptfield.label": "Pokyn",
  "promptfield.placeholder": "Jste připraveni začít? Položte otázku, podělte se o svůj nápad nebo přidejte úkol.",
  "promptfield.placeholder.small": "Zeptejte se na cokoli",
  "promptfield.stopButton": "Zastavit",
  "promptfield.submitButton": "Odeslat",
  "promptfield.uploading": "Nahrávání",
  "responsestatus.loading": "Načítání",
  "responsestatus.processing": "Zpracování...",
  "voicebutton.startListening": "Zahájit záznam",
  "voicebutton.stopListening": "Zastavit záznam"
}
